export enum PaymentErrorEnum {
  LIABILITIES_WITH_UNKNOWN_STATUS = 'LIABILITIES_WITH_UNKNOWN_STATUS',
  CUSTOMER_CART_LIMIT_REACHED = 'CUSTOMER_CART_LIMIT_REACHED',
  BLOCKING_PAYMENTS = 'BLOCKING_PAYMENTS',
  NO_SUGGESTED_LIABILITY_TO_PAY = 'NO_SUGGESTED_LIABILITY_TO_PAY',
}
